
import { defineComponent } from 'vue';
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButtons, IonButton, IonIcon } from '@ionic/vue';
import { arrowBackOutline } from 'ionicons/icons';
import DocContent from './DocContent.vue';
import { DocFull, getDoc, lastSeenVersion, markSeen } from '../../docsHelp';

export default defineComponent({
  name: 'HelpDoc',
  components: { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButtons, IonButton, IonIcon, DocContent },
  data() {
    return { doc: null as DocFull | null, loading: true, offline: false, updatedNote: null as string | null, arrowBackOutline };
  },
  computed: {
    anchor(): string | null {
      return (this.$route.hash || '').replace(/^#/, '') || null;
    },
  },
  watch: {
    '$route.params.slug'(slug: string) {
      if (slug) {
        this.load(slug);
      }
    },
  },
  created() {
    this.load(this.$route.params.slug as string);
  },
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.push('/help');
      }
    },
    async load(slug: string) {
      this.loading = true;
      const result = await getDoc(slug);
      this.doc = result.doc;
      this.offline = result.offline;
      this.loading = false;
      if (this.doc) {
        const seen = lastSeenVersion(slug);
        this.updatedNote = seen > 0 && seen < this.doc.version ? this.doc.change_summary : null;
        markSeen(slug, this.doc.version);
      }
    },
  },
});
